import * as React from 'react';
import { IconChevronUp16, Button } from '@cian/ui-kit';

import { TMobileListProps } from './container';
import * as styles from './index.css';
import { MobileListItemContainer } from '../../../containers/MobileListItem';
import { scrollToTop } from '../../../utils/scrollToTop';
import { NotFoundContainer } from '../../../containers/NotFoundContainer';

export const MobileList = ({
  isShowMoreVisible,
  isFetching,
  filters,
  paginatedList,
  regionHasRoads,
  fetchVillages,
}: TMobileListProps) => {
  if (!paginatedList) {
    return (
      <div className={styles['not-found']}>
        <NotFoundContainer />
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      {paginatedList.map((list, page) => (
        <div key={`page_${page}`}>
          {list.map(village => (
            <MobileListItemContainer
              key={village.id}
              village={village}
              filters={filters}
              regionHasRoads={regionHasRoads}
            />
          ))}
        </div>
      ))}
      {isShowMoreVisible && (
        <div className={styles['actions']}>
          <Button
            fullWidth
            loading={isFetching}
            onClick={() => fetchVillages(paginatedList.length + 1)}
            aria-label="Показать ещё"
          >
            Показать ещё
          </Button>

          <div className={styles['scroll-top']}>
            <Button
              theme="fill_secondary"
              beforeIcon={<IconChevronUp16 color="primary_100" />}
              onClick={() => scrollToTop(300)}
              aria-label="Наверх"
            />
          </div>
        </div>
      )}
    </div>
  );
};
